export default "__VITE_ASSET__DPlC6W9r__"